module.exports = __webpack_public_path__ + "media/svg/neutral_dark_horizontal-b127288f.svg";